/* tslint:disable */
/* eslint-disable */
/**
 * Ad Asset Generation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the ImgPromptRequest interface.
 */
export function instanceOfImgPromptRequest(value) {
    return true;
}
export function ImgPromptRequestFromJSON(json) {
    return ImgPromptRequestFromJSONTyped(json, false);
}
export function ImgPromptRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
        'antiprompt': json['antiprompt'] == null ? undefined : json['antiprompt'],
        'dimensions': json['dimensions'] == null ? undefined : json['dimensions'],
        'transparency': json['transparency'] == null ? undefined : json['transparency'],
    };
}
export function ImgPromptRequestToJSON(json) {
    return ImgPromptRequestToJSONTyped(json, false);
}
export function ImgPromptRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'prompt': value['prompt'],
        'antiprompt': value['antiprompt'],
        'dimensions': value['dimensions'],
        'transparency': value['transparency'],
    };
}
